import VueRouter from "vue-router";
import {Routes} from "./routes";
import Vue from 'vue'

Vue.use(VueRouter);

/**
 * Create the router instance and pass the `routes` option
 *
 * @type {VueRouter}
 */
const Router = new VueRouter({
    routes: Routes,
    mode: 'history'
});

Router.beforeEach((to, from, next) => {
    let title = "Page Title";

    if (to.matched instanceof Array && to.matched.length === 0) {
        title = "Page not found"

        // TODO: Show some page not found page
    }

    if (to.meta.title) {
        title = to.meta.title;
    }

    document.title = title + " - CryoHost";
    next()
});

export default Router;

